// @ts-nocheck
namespace $ {
	
	type DuckDB = typeof import('./.npm/.app')
	type AsyncDuckDB = InstanceType< DuckDB['AsyncDuckDB'] >
	type AsyncDuckDBConnection = Awaited< ReturnType< AsyncDuckDB['connect'] > >
	type DuckDBBundle = import('./.npm/.app').DuckDBBundle

		export class $shm_duckdb extends $mol_object2 {

		static _db: AsyncDuckDB
		static _db_promise: Promise< AsyncDuckDB > | null = null
		static _file_urls = new Map< string, string >
		static _bundle_urls = new Map< string, string >
		static _table_writes = new Map< string, Promise< string > >

		@ $mol_mem
		static lib() {
			$mol_wire_solid()
			return $mol_import.script( 'shm/duckdb/bundle/app.js' ).$shm_duckdb_npm as DuckDB
		}

		static lib_async() {
			return $mol_wire_async( this ).lib()
		}

		@ $mol_mem
		static db() {
			$mol_wire_solid()
			return $mol_wire_sync( this ).db_async()
		}

		static async db_async() {
			if( this._db ) return this._db
			if( this._db_promise ) return this._db_promise

			this._db_promise = ( async ()=> {
				const lib = await this.lib_async()
				const bundle = await lib.selectBundle( this.local_bundles() )
				this._db = await this.db_make( bundle )
				return this._db
			} )()

			try {
				return await this._db_promise
			} catch( error ) {
				this._db_promise = null
				throw error
			}
		}

		static local_bundles() {
			const uri = ( path: string )=> new URL( path, $mol_dom_context.location.origin ).toString()
			return {
				mvp: {
					mainModule: uri( '/shm/duckdb/bundle/duckdb-mvp.wasm' ),
					mainWorker: uri( '/shm/duckdb/bundle/duckdb-browser-mvp.worker.js' ),
				},
				eh: {
					mainModule: uri( '/shm/duckdb/bundle/duckdb-eh.wasm' ),
					mainWorker: uri( '/shm/duckdb/bundle/duckdb-browser-eh.worker.js' ),
				},
			}
		}
		
		static async db_make( bundle: DuckDBBundle ) {
			if( !bundle.mainWorker ) throw new Error( 'DuckDB bundle has no mainWorker' )
			const lib = await this.lib_async()
			const worker_url = await this.bundle_url( bundle.mainWorker )
			const module_url = await this.bundle_url( bundle.mainModule )
			const worker = await lib.createWorker( worker_url )
			const logger = new lib.ConsoleLogger()
			const db = new lib.AsyncDuckDB( logger, worker )

			worker.addEventListener( 'error', (event: any) => {
				console.error( 'duckdb worker error', event )
				if( this._db === db ) {
					this._db = null as any
					this._db_promise = null
				}
			} )
			worker.addEventListener( 'messageerror', (event: any) => {
				console.error( 'duckdb worker messageerror', event )
				if( this._db === db ) {
					this._db = null as any
					this._db_promise = null
				}
			} )

			try {
				await db.instantiate( module_url, bundle.pthreadWorker )
			} catch( error ) {
				await db.terminate()
				throw error
			}
			
			return db
		}

		static async bundle_url( source: string ) {
			const cached = this._bundle_urls.get( source )
			if( cached ) return cached

			const response = await $mol_dom_context.fetch( source )
			if( !response.ok ) throw new Error( `DuckDB asset ${ response.status }: ${ source }` )
			const url = URL.createObjectURL( await response.blob() )
			this._bundle_urls.set( source, url )
			return url
		}

		static async reset_async() {
			const db = this._db
			this._db = null as any
			this._db_promise = null

			for( const url of this._file_urls.values() ) URL.revokeObjectURL( url )
			this._file_urls.clear()
			for( const url of this._bundle_urls.values() ) URL.revokeObjectURL( url )
			this._bundle_urls.clear()

			if( db ) await db.terminate()
		}

		
		static async file_query( file_name: string, buffer: Uint8Array, query: string ) {
			let conn_prom: Promise<AsyncDuckDBConnection> | null
			const load_db = async () => {
				if( conn_prom ) {
					return conn_prom
				}
				const db = await this.db()
				await db.registerFileBuffer( file_name, buffer )
				conn_prom = db.connect()
				return conn_prom
			}

			const get_query = async ( q: string ) => {
				const conn = await conn_prom
				const results = await conn!.query( q )
				conn?.close()
				// for await (const batch of await conn!.send(viz_query)) {
				// 	console.log('batch', batch)
				// }
				return results
			}

			await load_db()
			const table = await get_query( query )
			const table_arr = table.slice(0, 100).toArray()

			const result = table_arr.map( ( row: any ) => row.toJSON() )
			return result
		}

		static async connection() {
			const db = await this.db_async()
			return await db.connect()
		}

		static async connect_files_async( sources: any ) {
			const connection = await $shm_duckdb.connection()

			await $shm_duckdb.register_files_async( sources )

			return connection
		}

		static async register_files_async( sources: any ) {
			const db = await this.db_async()

			for (const f of sources) {
				const name = f.title()
				if( !name ) continue

				try {
					await db.dropFile( name )
				} catch( error ) {
					// DuckDB has no "drop if exists" for registered files.
				}

				const blob = await $mol_wire_async( f ).blob()
				if( !blob ) continue

				const buf = await blob.arrayBuffer()
				await db.registerFileBuffer( name, new Uint8Array( buf ) )
			}
		}

		static async register_files_url_async( sources: any ) {
			const db = await this.db_async()
			const lib = await this.lib_async()

			for( const file of sources ) {
				const name = file.title()
				if( !name ) continue

				const prev_url = this._file_urls.get( name )
				if( prev_url ) {
					await db.dropFile( name )
					URL.revokeObjectURL( prev_url )
				}

				const blob = await $mol_wire_async( file ).blob()
				if( !blob ) continue

				const url = URL.createObjectURL( blob )
				this._file_urls.set( name, url )
				const DuckDBDataProtocolBrowserFilereader = 2
				await db.registerFileURL( name, url, DuckDBDataProtocolBrowserFilereader, false )

			}
		}
		
		@ $mol_action
		static connect_json( table_name: string, json?: any ) {
			return $mol_wire_sync($shm_duckdb).connect_json_async( table_name, json! )
		}

		static async connect_json_async( table_name: string, json: any ) {

			const db = await this.db_async()
			const connection = await $shm_duckdb.connection()

			const file_name = table_name + '.json'

			await db.registerFileText(
				file_name,
				JSON.stringify(json),
			)
			await connection.insertJSONFromPath( file_name, { name: table_name, create: true } )

			return connection
		}
		
		@ $mol_mem
		static connect_files( sources?: any ) {
			return $mol_wire_sync($shm_duckdb).connect_files_async( sources! )
		}
		
		@ $mol_action
		static files_query( files: any, query: string, limit?: number ) {
			const conn = $shm_duckdb.connect_files( files )
			const table = $mol_wire_sync(conn).query( query )
			const res = this.get_head_and_rows( limit ? table.slice( 0, limit ) : table )
			return res
		}

		static async files_query_async( files: any, query: string, limit?: number ) {
			const db = await this.db_async()
			const conn = await $shm_duckdb.connect_files_async( files )
			const file_names = [ ...new Set( files.map( file => file.title()! ) ) ]
			try {
				const table = await conn.query( query )
				return this.get_head_and_rows( limit ? table.slice( 0, limit ) : table )
			} finally {
				await conn.close()
				if( file_names.length ) await db.dropFiles( file_names )
			}
		}

		static async files_run_async( files: any, query: string ) {
			const db = await this.db_async()
			const conn = await $shm_duckdb.connect_files_async( files )
			const file_names = [ ...new Set( files.map( file => file.title()! ) ) ]
			try {
				await conn.query( query )
			} finally {
				await conn.close()
				if( file_names.length ) await db.dropFiles( file_names )
			}
		}
		
		@ $mol_action
		static json_query( table_name: string, json: any, query: string, limit?: number ) {
			$shm_duckdb.connection_query( `DROP TABLE IF EXISTS ${table_name};` )
			const conn = $shm_duckdb.connect_json( table_name, json )
			const table = $mol_wire_sync(conn).query( query )
			const res = this.get_head_and_rows_from_vectors( limit ? table.slice( 0, limit ) : table )
			return res
		}
		
		@ $mol_action
		static connection_query( query: string, limit?: number ) {
			const conn = $mol_wire_sync($shm_duckdb).connection()
			try {
				const table = $mol_wire_sync(conn).query( query )
				const res = this.get_head_and_rows_from_vectors( limit ? table.slice( 0, limit ) : table )
				return res
			} finally {
				$mol_wire_sync(conn).close()
			}
		}

		static async connection_run_async( query: string ) {
			const conn = await $shm_duckdb.connection()
			try {
				await conn.query( query )
			} finally {
				await conn.close()
			}
		}

		@ $mol_action
		static table_from_json( table_name: string, rows: readonly Record< string, unknown >[] ) {
			return $mol_wire_sync( this ).table_from_json_async( table_name, rows )
		}

		static async table_from_json_async( table_name: string, rows: readonly Record< string, unknown >[] ) {
			const previous = this._table_writes.get( table_name ) ?? Promise.resolve( table_name )
			const current = previous
				.catch( ()=> table_name )
				.then( ()=> this.table_from_json_write_async( table_name, rows ) )
			this._table_writes.set( table_name, current )

			try {
				return await current
			} finally {
				if( this._table_writes.get( table_name ) === current ) this._table_writes.delete( table_name )
			}
		}

		static async table_from_json_write_async( table_name: string, rows: readonly Record< string, unknown >[] ) {
			const db = await this.db_async()
			const conn = await this.connection()
			const table = this.sql_identifier( table_name )
			const stage_name = `${ table_name }__json_stage`
			const stage = this.sql_identifier( stage_name )
			const file_name = `${ table_name }.json`

			try {
				try {
					await db.dropFile( file_name )
				} catch( error ) {
				}

				await conn.query( `DROP TABLE IF EXISTS ${ stage }` )
				await db.registerFileText( file_name, JSON.stringify( rows ) )
				await conn.insertJSONFromPath( file_name, { name: stage_name, create: true } )
				await conn.query( `
					CREATE OR REPLACE TABLE ${ table } AS
					SELECT
						CAST( "Запрос" AS VARCHAR ) AS "Запрос",
						CAST( "Регион" AS VARCHAR ) AS "Регион",
						CAST( "Периодичность" AS VARCHAR ) AS "Периодичность",
						CAST( "Устройство" AS VARCHAR ) AS "Устройство",
						CAST( "Дата" AS DATE ) AS "Дата",
						CAST( "Кол-во" AS BIGINT ) AS "Кол-во",
						CAST( "Доля" AS VARCHAR ) AS "Доля"
					FROM ${ stage };
				` )
				await conn.query( `DROP TABLE IF EXISTS ${ stage }` )
			} finally {
				await conn.close()
			}

			return table_name
		}

		static async files_view_async( view_name: string, files: any, query: string ) {
			await $shm_duckdb.register_files_url_async( files )
			const view_ident = $shm_duckdb.sql_identifier( view_name )
			await $shm_duckdb.connection_run_async( `DROP VIEW IF EXISTS ${ view_ident }` )
			await $shm_duckdb.connection_run_async( `DROP TABLE IF EXISTS ${ view_ident }` )
			await $shm_duckdb.connection_run_async( `CREATE VIEW ${ view_ident } AS ${ query }` )
		}

		static sql_identifier( name: string ) {
			return '"' + String( name ).replaceAll( '"', '""' ) + '"'
		}

		@ $mol_action
		static table_names() {
			const { rows } = $shm_duckdb.connection_query( `
				SELECT table_name
				FROM information_schema.tables
				WHERE table_schema = 'main'
				ORDER BY table_name
			` )
			return rows.map( row => String( row[0] ) )
		}

		@ $mol_action
		static table_select( table_name: string, limit?: number ) {
			return $shm_duckdb.connection_query(
				`SELECT * FROM ${ $shm_duckdb.sql_identifier( table_name ) }`,
				limit,
			)
		}

		@ $mol_action
		static table_head( table_name: string ) {
			const { head } = $shm_duckdb.connection_query(
				`SELECT * FROM ${ $shm_duckdb.sql_identifier( table_name ) } LIMIT 0`,
			)
			return head
		}

		static get_head_and_rows_from_vectors( table: Awaited<ReturnType<ReturnType<typeof $shm_duckdb.connect_files>[ 'query' ]>> ) {

			const head: string[] = table.schema.fields.map( ( f: any ) => f.name )

			const rows: any[] = []
			;[...table].forEach( ( row: any ) => {
				const json = row.toJSON()
				
				const vals = table.schema.fields.map( ( f: any ) => format_val( f, json[ f.name ] ) )
				const is_vectors = table.schema.fields.every( ( f: any ) => f.type.typeId == 12 )

				if( !is_vectors ) {
					rows.push( vals )
					return
				}
				
				vals.forEach( ( vec: any, col_i: any )=> {
					const vals: any[] = vec.toJSON()
					vals.forEach( ( v, row_i ) => {
						rows[ row_i ] = rows[ row_i ] ?? []
						rows[ row_i ][ col_i ] = format_val( vec, v )
					} )
				} )
			} )

			return { head, rows }

		}

		static get_head_and_rows( table: Awaited<ReturnType<ReturnType<typeof $shm_duckdb.connect_files>[ 'query' ]>> ) {

			const head: string[] = table.schema.fields.map( ( f: any ) => f.name )

			const rows: any[] = [...table].map( ( row: any ) => {
				const json = row.toJSON()
				return table.schema.fields.map( ( f: any ) => format_val( f, json[ f.name ] ) )
			} )

			return { head, rows }

		}

	}

	function format_val( field: any, val: any ) {
		if( val === null ) return ''

		if( field.type.typeId == 8 ) {
			const date = new $mol_time_moment( val )
			return date.toString('DD.MM.YYYY')
		}

		if( field.type.typeId == 7 ) { //Decimal
			return String( val )
		}

		if( typeof val === "bigint" ) return String( val )

		return val
	}

}
